import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const kurla: AreaConfig = {
  name: 'Kurla',
  slug: 'kurla',
  tagline: 'Doorstep Mobile Repair in Kurla, Mumbai',
  description:
    'Kurla connects the Central and Harbour lines — and Minto connects you to fast doorstep mobile repair. Our certified technicians cover Kurla East, West, BKC adjacent, Chunabhatti, and Chembur. Repair done in under an hour.',
  localities: [
    'Kurla East', 'Kurla West', 'Vidyavihar', 'Chunabhatti', 'Sion',
    'Dharavi', 'BKC adjacent', 'Tilak Nagar', 'Nehru Nagar', 'Vinobha Bhave Nagar',
    'Sakinaka', 'CSMT Cargo',
  ],
  zones: [
    {
      name: 'Kurla West & BKC Adjacent',
      line: 'Central Line',
      station: 'Kurla West Station',
      localities: ['Kurla West', 'BKC adjacent', 'Nehru Nagar', 'Bandra–Kurla border', 'LBS Marg', 'Vidyavihar West'],
      desc: 'Kurla West borders BKC and is heavily commercial. We service offices and residences alike in this zone.',
    },
    {
      name: 'Kurla East & Vidyavihar',
      line: 'Central Line',
      station: 'Kurla East Station / Vidyavihar Station',
      localities: ['Kurla East', 'Vidyavihar', 'Tilak Nagar', 'Vinobha Bhave Nagar', 'Sakinaka', 'Eastern Express Highway'],
      desc: 'Covering the residential east side of Kurla and the Vidyavihar area. Fast doorstep service for all housing societies.',
    },
    {
      name: 'Chunabhatti, Sion & Dharavi',
      line: 'Harbour Line',
      station: 'Chunabhatti Station / Sion Station',
      localities: ['Chunabhatti', 'Sion', 'Sion Circle', 'Dharavi', 'Sion–Kurla Link Road', 'Sion–Koliwada'],
      desc: 'The Harbour line zone between Kurla and Sion is fully covered. Dharavi and Chunabhatti residents can book doorstep repairs easily.',
    },
  ],
  seo: {
    title: 'Mobile Repair in Kurla | Doorstep Phone Repair | Minto',
    description:
      'Doorstep mobile repair in Kurla East & West, Vidyavihar, Chunabhatti, Sion & Dharavi, Mumbai. Screen replacement, battery repair. 90-day warranty. Book now!',
    keywords:
      'mobile repair Kurla, phone repair Kurla, screen repair Kurla, battery replacement Kurla, iPhone repair Kurla, Samsung repair Kurla, Vidyavihar phone repair, Sion mobile repair, Chunabhatti phone repair, Dharavi mobile repair, doorstep repair Kurla',
  },
  faqs: [
    {
      q: 'Do you offer doorstep repair in Kurla West?',
      a: 'Yes, we cover Kurla West including the BKC-adjacent areas and LBS Marg corridor.',
    },
    {
      q: 'Do you also cover Sion and Chunabhatti near Kurla?',
      a: 'Yes, Sion, Chunabhatti, and Dharavi are covered under our Kurla service zone via the Harbour line belt.',
    },
    {
      q: 'How much does battery replacement cost in Kurla?',
      a: 'Battery replacement starts from ₹699 depending on your phone model.',
    },
    {
      q: 'Do you serve Vidyavihar near Kurla?',
      a: 'Yes, Vidyavihar East and West are fully covered as part of our Kurla service area.',
    },
    {
      q: 'What is the response time for repairs in Kurla?',
      a: 'Typically 60–90 minutes from booking. Kurla is well-covered by our Mumbai technician network.',
    },
  ],
};

const KurlaPage: React.FC = () => <AreaLandingPage area={kurla} />;
export default KurlaPage;
